import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { modalActions } from '../../../entities/Modal'
import CustomDialog from '../../../shared/ui/CustomDialog/CustomDialog'
import DOMPurify from 'dompurify'

export const Show409Modal = () => {
	const dispatch = useAppDispatch()
	const errorContent = useAppSelector(state => state.modal.data)

	const isString = typeof errorContent === 'string'
	const sanitizedHTML = isString
		? DOMPurify.sanitize(errorContent, {
			USE_PROFILES: { html: true }
		})
		: ''

	const handleClose = () => {
		dispatch(modalActions.hideModal())
	}

	return (
		<CustomDialog
			dialogTitle="Conflict"
			handleClose={handleClose}
		>
			{errorContent ? (
				<div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
			) : (
				<>
					Operation failed:
					the target entity cannot be modified because it has existing
					references to another entity
				</>
			)}
		</CustomDialog>
	)
}